<p-modal [open]="open" (dismiss)="close()">
  <p-heading slot="header" [size]="'large'" [tag]="'h2'">
    Edit {{ vpnSubscriptionType?.name }}
  </p-heading>

  <form class="form" [formGroup]="form" [id]="formId" (ngSubmit)="submit()">
    <p-text-field-wrapper
      *ngrxLet="form.controls.name as control"
      [label]="'Name'"
      [message]="control.errors?.['message'] ?? ''"
      [state]="control.touched && control.errors ? 'error' : 'none'"
    >
      <input type="text" [attr.required]="true" [formControl]="control" />
    </p-text-field-wrapper>

    <p-text-field-wrapper
      *ngrxLet="form.controls.cost as control"
      [label]="'Cost'"
      [message]="control.errors?.['message'] ?? ''"
      [state]="control.touched && control.errors ? 'error' : 'none'"
      [unit]="defaultCurrencyCode"
      [unitPosition]="'suffix'"
    >
      <input type="number" [attr.required]="true" [formControl]="control" />
    </p-text-field-wrapper>

    <p-text-field-wrapper
      *ngrxLet="form.controls.allowedMonthlyOverage as control"
      [label]="'Allowed Monthly Overage'"
      [message]="control.errors?.['message'] ?? ''"
      [state]="control.touched && control.errors ? 'error' : 'none'"
      [unit]="defaultCurrencyCode"
      [unitPosition]="'suffix'"
    >
      <input type="number" [attr.required]="true" [formControl]="control" />
    </p-text-field-wrapper>

    <div class="switch-control">
      <p-text>VPN Subscription Type Status</p-text>
      <p-switch
        *ngrxLet="form.controls.active as control"
        [checked]="control.value ?? undefined"
        [disabled]="control.disabled"
        (update)="control.patchValue($event.detail.checked)"
      >
        Active
      </p-switch>
    </div>
  </form>

  <p-button-group slot="footer">
    <p-button [form]="formId" [loading]="(submitting$ | async) ?? false" [type]="'submit'">
      Save
    </p-button>
    <p-button [iconSource]="'assets/icons/close.svg'" [variant]="'secondary'" (click)="close()">
      Close
    </p-button>
  </p-button-group>
</p-modal>
